<template>
  <div>
    <sea-page
      title="Cronologia avviso"
      header="Cronologia avviso"
      showCompanyHeader
      back
    >
      <sea-page-content :fetchList="fetchList" toolbar pulsanteAggiorna>
        <template v-slot:table="{ attrs, height }">
          <v-data-table
            v-bind="attrs"
            :height="height"
            :headers="headers"
            :items="avviso.users"
            dense
            sort-by="lastName"
          >
            <template v-slot:item.dataLettura="{ item }">
              {{ item.dataLettura | dateFormat }}
            </template>
            <template v-slot:item.letto="{ item }">
              <check-icon :checked="item.letto"></check-icon>
            </template>
          </v-data-table>
        </template>
        <div class="font-weight-bold">
          Data invio:
          {{ avviso.data | dateFormat }} Titolo:
          {{ avviso.titolo }}
        </div>
      </sea-page-content>
    </sea-page>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

const headers = [
  { text: "Cognome", value: "lastName" },
  { text: "Nome", value: "firstName" },
  { text: "Letto", value: "letto" },
  { text: "Data lettura", value: "dataLettura", filterable: false },
];

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setCurrentId(to.params.id);
    });
  },
  data() {
    return {
      headers,
    };
  },
  methods: {
    ...mapActions({
      setCurrentId: "board/setCurrentId",
      fetchList: "board/fetchHistory",
    }),
  },
  computed: {
    ...mapGetters({
      avviso: "board/notice",
    }),
  },
};
</script>

<style>
</style>